let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8lFsj")).then(() => parcelRequire('1vlnd'));